/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSubjectStatus.defs'
export { main as default } from './getSubjectStatus.defs'
